<template>
    <div class="role">
        <div style="padding: 10px 0;display: flex;justify-content: space-between;">
            <div>
                <el-button style="color: #000" @click="adduser">新增</el-button>
<!--                <el-button style="color: #000" @click="delAll">批量删除</el-button>-->
            </div>　　　　
            <div class="screen_item">
                <el-input v-model="params.vc_name" placeholder="角色名" clearable
                          prefix-icon="el-icon-search" style="width: 230px;">

                </el-input>
                <span  @click="sercher" style="" class="searchuser">搜索</span>
            </div>
        </div>
    <el-table
            :data="rolelist"
            border
            style="width: 100%"
            :header-cell-style="{'text-align':'center',background:'#eef1f6',color:'#000'}"
            :cell-style="{'text-align':'center'}" v-loading="loading">
        <el-table-column
                prop="vc_name"
                label="角色名"
                width="180">
        </el-table-column>
        <el-table-column
                prop="vc_lruname"
                label="姓名"
                width="180">
        </el-table-column>
        <el-table-column
                prop="dt_createtime"
                label="录入时间">
        </el-table-column>
        <el-table-column
                prop="i_state"
                label="用户状态">
            <template slot-scope="scope">
                <div v-if="scope.row.i_state==1"><i class="el-icon-check"></i></div>
                <div v-if="scope.row.i_state==0"><i class="el-icon-close"></i></div>
            </template>
        </el-table-column>
        <el-table-column
                prop="i_type"
                label="角色类型">
            <template slot-scope="scope">
            <div v-if="scope.row.i_type==1">admin</div>
            <div v-if="scope.row.i_type==2">平台级</div>
            <div v-if="scope.row.i_type==3">企业级</div>
            <div v-if="scope.row.i_type==4">普通级</div>
        </template>
        </el-table-column>
    </el-table>
        <div style="text-align: center;padding: 20px 0">
            <el-pagination
                    background
                    layout="prev, pager, next"
                    @current-change="pageCurrentChange"
                    :total="totalList" :page-size="pageSize">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import * as API from "./api";
    import {mapActions} from "vuex";
    export default {
        name:"role",
        data() {
            return {
                loading:false,
                rolelist: [],
                pageSize:4,
                totalList:4,
                pageIndex:1,
                params: {
                    vc_name: ""
                },
                mid:'',
            }
        },
        mounted() {
            this.getlist()
        },
        methods:{
        ...mapActions(["getCurrentMenuId"]),
                //获取table
                async getlist() {
            this.loading=true;
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if(result.i_id!==""){
                    this.mid=result.i_id;
                    sessionStorage.setItem('mids',result.i_id)
                }else {
                    this.mid=sessionStorage.getItem('mids')
                }
                let param = {
                    i_mid: this.mid,
                    pageStart: (this.pageIndex-1)*this.pageSize,
                    pageSize: this.pageSize,
                    vc_name: this.params.vc_name==""?null:this.params.vc_name,
                };

                let res = await API.getList(param);
                if (res.code == 1) {
                    this.loading=false;
                    this.rolelist = res.roleList;

                } else if(res.code==-2){
                    this.loading=false;
                        this.$router.push('/login')
                        this.$message.error(res.message);
                    }else {
                    this.loading=false;
                    this.$message.error(res.message);
                }
            },
            //获取当前页数据
            pageCurrentChange(val){
                this.pageIndex=val;
                this.getlist();
            },
            //新增
            adduser(){

            },
            //搜索
            sercher(){
                this.getlist()
            },

        },
    }
</script>
<style lang="scss">
.role {
}
.screen_item{
    display: flex;
    width: 280px;
    .el-input__inner{
        border-top-left-radius: 46px;
        border-bottom-left-radius: 46px;

    }
}
.searchuser{
    background: #3e82e8;
    color: #fff;
    height: 40px;
    line-height: 40px;
    width: 80px;
    font-size: 14px;
    text-align: center;
    cursor: pointer;
    border-radius: 0 27px 27px 0;
}
</style>